import { useMsRemaining } from "@nova/toolkit-pure-hooks"
import classNames from "classnames"

const HOUR_MS = 60 * 60_000

type PieColor = "red" | "yellow" | "green"

const pieColorHex: Record<PieColor, string> = {
    red: "#BB4D00", // atlas ds color/yellow/700
    yellow: "#E1AD00", // atlas ds color/yellow/500
    green: "#139E3B", // atlas ds color/green/600
}
const trackColorHex = "#34353B" // gray-600

export const getTimeRemainingPieColor = (msRemaining: number) => {
    const minutesRemaining = msRemaining / 60_000
    if (minutesRemaining <= 15) return "red"
    if (minutesRemaining <= 30) return "yellow"
    return "green"
}

export const TimeRemainingPie = ({
    expiresAt,
    className,
}: {
    expiresAt: number | undefined
    className?: string
}) => {
    const msRemaining = useMsRemaining({ timestamp: expiresAt })
    if (msRemaining === undefined) return null

    const fraction = Math.min(Math.max(msRemaining, 0), HOUR_MS) / HOUR_MS
    const sweepDeg = fraction * 360

    return (
        <div
            className={classNames("w-5 h-5 rounded-full shrink-0", className)}
            style={{
                background: `conic-gradient(${pieColorHex[getTimeRemainingPieColor(msRemaining)]} ${sweepDeg}deg, ${trackColorHex} ${sweepDeg}deg)`,
            }}
        />
    )
}
